import { useState, useEffect, Fragment } from "react";
import { Card, Col, Row, Table, Button } from "react-bootstrap";
import {ArrowLeftCircle, PencilSquare, Trash} from "react-bootstrap-icons";
import { useSelector, useDispatch  } from "react-redux";
import AccessPointDetails from "app/views/AccessPoint/AccessPointDetails";
import { useLazyGetPropertyFloorEntranceQuery } from "app/redux/Building/buildingApi";
import AddCustomerModal from "../modal/AddCustomerModal";
import { useLazyGetAccessGroupUsersQuery } from "app/redux/Users/Accessusers/accessUsersApi";
import { accessUserAction } from "app/redux/Users/Accessusers/accessUserSlice";
import Breadcrumb from "app/components/Breadcrumb";
import useFullPageLoader from "app/hooks/useFullPageLoader ";
import ContractDetails from "app/views/app/contract/ContractDetail";
import AccessGroupDetail from "app/views/AccessGroup/AccessGroupDetails";
import swal from "sweetalert2";
import { useLazyArchiveUnarchiveCustomersQuery } from "app/redux/CRMManager/customerCRMApi";
import { useLazyDeleteAMSUserQuery } from "app/redux/AMS/amsApi";
import { toast } from "react-toastify";

function UserDetails({ open, handleClose, eventObject }) {
    const [userloading, setUserLoading] = useState(false);
    const[archiveUnarchiveCustomers] = useLazyArchiveUnarchiveCustomersQuery();
    const[deleteAMSUser] = useLazyDeleteAMSUserQuery();
    const [getAccessGroupUsers] = useLazyGetAccessGroupUsersQuery();
    const [modalState, setModalState] = useState({
        AccessPointObject: {},
        eventDialogOpen: false,
        
    });
    const [accessGroupmodalState, setAccessGroupModalState] = useState({
      accessGroupEventObject: {},
      accessGroupEventDialogOpen: false,
     
    });
    const [getPropertyFloorEntrance] = useLazyGetPropertyFloorEntranceQuery();
    const [companyAccessPointListData, setState] = useState([]);
    const { selectedCompanyId } = useSelector((state) => state.company);
    const [accessGroupDetails, setAccesGroupDetails] = useState([]);
    const [propertyUnitDetails, setPropertyUnitDetails] = useState([]);
    const [addCustomerModalState, setAddCustomerModalState] = useState({
      dialogValues: null,
      showEditorDialog: false,
      customerId: 0
    });
    const[userItem, setUserItemState] = useState({});
    const dispatch = useDispatch();
    const [contractmodalState, setcontractModalState] = useState({contractEventObject: {},contractEventDialogOpen: false});
   
    let item = eventObject.item;
    let accessPointList = eventObject.item.AccessPoints;

    const companyAccessPointList = useSelector((state) => {
        return state.facility.companyAccessPointList;
    });

    const propertyFloorEntranceList = useSelector((state) => {
        return state.building.BuildingFloorEntranceList;
    });

    const [loader, showLoader, hideLoader] = useFullPageLoader();


    useEffect(() => {
        console.log('eventObject.item - ', item );
        setUserItemState(item);
        modifyFacilityObject(companyAccessPointList);
        //setState(companyAccessPointList);
        if(propertyFloorEntranceList){
            mergeArrayInObject(propertyFloorEntranceList.AccessGroupDetail);
            mergePropertyUnitArrayObject(propertyFloorEntranceList.PropertyUnitsDetail);
        }
        else{
            if (selectedCompanyId) {
                localStorage.setItem('CompanyId',selectedCompanyId);
                getPropertyFloorEntrance({
                  propertyid: 0,
                  type: "FORFACILITY",
                }).then((result) => {
                  //console.log('getPropertyFloorEntrance - ',result);
                  if (result.data.data.AccessGroupDetail?.length > 0) {
                    mergeArrayInObject(result.data.data.AccessGroupDetail);
                    
                  }
                  if (result.data.data.PropertyUnitsDetail?.length > 0) {
                    mergePropertyUnitArrayObject(result.data.data.PropertyUnitsDetail);
                  }
                });
            }
        }
        
    }, [companyAccessPointList]);

    const mergeArrayInObject = (rawData) =>
        {
          let mainObj = [];
          if (Array.isArray(rawData)){
            rawData.forEach((item) => {
              let tempObj = {};
              tempObj = item;
              tempObj = {
                ...item,
                value: item.ConcatID ,
                label: item.UnitName,
                checked: false,
                children: []
              };
              if (item.PropertyEntranceFloors){
                const entranceData = JSON.parse(item.PropertyEntranceFloors);
                entranceData.forEach((entranceItem) => {
                  let entranceTempObj = {};
                  entranceTempObj = {
                    ...entranceItem,
                    value: entranceItem.ConcatID ,
                    label: entranceItem.UnitName,
                    checked: false,
                    children: []
                  };
                  const floorEntranceData = entranceItem.PropertyFloors;
                  if (floorEntranceData){
                    floorEntranceData.forEach((floorEntranceItem) => {
                      let floorTempObj = {};
                      floorTempObj = {
                        ...floorEntranceItem,
                        value: floorEntranceItem.ConcatID ,
                        label: floorEntranceItem.UnitName,
                        checked: false
                      };
                      entranceTempObj.children.push(floorTempObj);
                    });
                  }
                  tempObj.children.push(entranceTempObj);
                });
              }
              mainObj.push(tempObj);
            });
          }
          setAccesGroupDetails(mainObj);
        }
    
        const mergePropertyUnitArrayObject = (rawData) =>
          {
            let mainObj = [];
            if (Array.isArray(rawData)){
              rawData.forEach((item) => {
                let tempObj = {};
                tempObj = item;
                tempObj = {
                  ...item,
                  value: item.ID,
                  ConcatName: item.Name,
                  label: item.Name,
                  checked: false,
                  children: []
                };
                mainObj.push(tempObj);
              });
            }
            setPropertyUnitDetails(mainObj);
          }

    const handleAccessPointClick = (item) => {
        const facilityData = companyAccessPointListData.filter(a => a.FacilityId === item.FacilityId)[0];
        if(facilityData){
            //console.log('facilityData - ',facilityData);
        }

        // -- PREPARING OPTIONS WITH CHECKED/SELECTED VALUES
        const OptionsPUIncluded = [];
        const OptionsPUExcluded = [];

        const selectedIdsPUInc = [];
        const selectedIdsPUExc = [];

        if(Array.isArray(facilityData.IncludedPU)){
            facilityData.IncludedPU.forEach(incItem => {
            selectedIdsPUInc.push(incItem.PropertyUnitId);
        })
        }
        if(Array.isArray(facilityData.ExcludedPU)){
            facilityData.ExcludedPU.forEach(excItem => {
            selectedIdsPUExc.push(excItem.PropertyUnitId);
        })
        }

        if(Array.isArray(propertyUnitDetails)){
            propertyUnitDetails.forEach(puItem => {
              const itemPuInc = Object.assign({}, puItem);
              const itemPuExc = Object.assign({}, puItem);
              itemPuInc.checked = (selectedIdsPUInc.includes(itemPuInc.ID))? true: false;
              itemPuExc.checked = (selectedIdsPUExc.includes(itemPuExc.ID))? true: false;
              OptionsPUIncluded.push(itemPuInc);
              OptionsPUExcluded.push(itemPuExc);
            })
          }

        const OptionsAccessGroup = prepareAccessGroupData(accessGroupDetails, facilityData.AccessGroup);

        setModalState((prevState) => ({
        ...prevState,
        eventDialogOpen: true,
        AccessPointObject: { type: "",selectedCompanyId: selectedCompanyId, facilityId: facilityData.FacilityId, facilityName: facilityData.FacilityName, item: facilityData, selectedGroup: facilityData.AccessGroup, groupData: accessGroupDetails, OptionsAccessGroup, OptionsPUIncluded, OptionsPUExcluded}
        }));
        
    }

    const closeAccessPointModal = () => {
        setModalState((prev) => ({ ...prev, eventDialogOpen: false }));
      }

      const toggleEditorDialog = (arg) => {
        if (arg && arg.toString()) {
          setAddCustomerModalState((prevState) => ({ ...prevState, showEditorDialog: true, dialogValues: item, customerId: item.UserId }));
        } else {
          setAddCustomerModalState((prevState) => ({
            ...prevState,
            dialogValues: item,
            showEditorDialog: !addCustomerModalState.showEditorDialog,
            customerId: item.UserId
          }));
        }
      };
      const handleFormSubmit = async (values) => {
        showLoader()
        getAccessGroupUsers({
          companyId: selectedCompanyId,
          type: "GET_ACCESSGROUP",
        }).then((result) => {
          setUserLoading(false);
          if (result.data.data?.length > 0) {
            //console.log('setDetailAfterEdit - ', result.data.data);
            setDetailAfterEdit(result.data.data);
            dispatch(
              accessUserAction({
                accessUserList: result.data.data,
              })
            );
          }
          hideLoader();
        });
        toggleEditorDialog(false);
      };

    const setDetailAfterEdit = (data) => {
      const existingCustomerId = item.UserId;
      const getUpdatedData = data.filter(a => a.UserId === existingCustomerId);
      if(getUpdatedData && getUpdatedData[0]){
        item = getUpdatedData[0];
        setUserItemState(item);
      }
    }
    
    const closeContractModal = () => {
      setcontractModalState((prev) => ({ ...prev, contractEventDialogOpen: false }));
    }
  
    const handlePropertyUnitclick = (item) => {
      let eventData = {};
      eventData.ContractId = 0;
      eventData.PropertyUnitId = item.PropertyUnitID;
      eventData.PropertyUnitName = item.Propertyunit;
      setcontractModalState((prevState) => ({
        ...prevState,
        contractEventDialogOpen: true,
        contractEventObject: eventData
      }));
    }

    const handleAccessGroupClick = (item) => {
      //Get direct user
      console.log(item);
      const accessgroup = item.AccessGroup;
      const groupType = item.AccessType;
      const groupId = item.AccessId;
      const callingScreen = 'USERDETAIL';
      const amsAccessGroupId = '';
      //--------------
      // -- PREPARING OPTIONS WITH CHECKED/SELECTED VALUES
      const OptionsFacilityData = prepareAccessGroupData(companyAccessPointListData, null);
  
      setAccessGroupModalState((prevState) => ({
        ...prevState,
        accessGroupEventDialogOpen: true,
        accessGroupEventObject: { type: "",selectedCompanyId: selectedCompanyId, objectId: groupId, objectType: groupType, 
          CallingScreen: callingScreen,itemData: item,objectName: accessgroup,
          selectedAccessPoint: [], FacilityData: OptionsFacilityData,directUsers: [],
          customPropertyUnits: [], amsAccessGroupId: amsAccessGroupId
        }
      }));
    };

    const accessGroupToggleEventDialog = (accessGroupEventObject) => {
      setAccessGroupModalState((prev) => ({ ...prev, accessGroupEventDialogOpen: !prev.accessGroupEventDialogOpen }));
    };
    
    const handleEventAccessGroupDialogSubmit = async (values) => {
      handleClose(true);
    }

    const modifyFacilityObject = (rawData) =>
      {
        let mainObj = [];
        if (Array.isArray(rawData)){
          rawData.forEach((item) => {
            let tempObj = {};
            tempObj = item;
            tempObj = {
              FacilityId: item.FacilityId,
              FacilityName: item.FacilityName,
              value: item.FacilityId ,
              label: item.FacilityName,
              PlacementName: item.PlacementName,
              checked: false,
              children: []
            };
            mainObj.push(tempObj);
          });
        }
        setState(mainObj);
    }

    const handleDeleteUserEvent = async (values) => {
      const customerId = item.UserId;
      if(!customerId){
        return;
      }
      const options = {
        title: "Slett",
        text: "Er du sikker på å slette?",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#fff !important",
        confirmButtonText: "Ja, slett den!",
        cancelButtonText: "Nei"
      };
  
      try {
        const { isConfirmed } = await swal.fire(options);
        if (!isConfirmed)
        {
          return;
        } 
        else{
          await archiveUserFromVendor(customerId, true);
        }
      } catch (error) {}
      
    }

    const archiveUserFromVendor = async (customerId, isArchive) => {
      showLoader();

      try {
        const payload = {
          CustomerIds: customerId.toString(),
          IsArchive: isArchive,
        };

        const result = await archiveUnarchiveCustomers(payload);
        console.log('await archiveUnarchiveCustomers(payload); -- ', result);
        // SUCCESS ONLY WHEN HTTP SUCCESS
        if (result.isSuccess && (result.data === null || result.data === undefined)) {
          if (isArchive) {
            await deleteUserFromAMS(customerId);
          }
        } 
        // BACKEND RETURNED MESSAGE
        else if (result.isSuccess && result.data) {
          toast.error(result.data, { autoClose: 2000 });
        } 
        // HTTP ERROR
        else if (result.isError) {
          toast.error("Archive failed", { autoClose: 2000 });
        }

      } catch (error) {
        console.log("archive error", error);
        toast.error("Unexpected error", { autoClose: 2000 });
      } finally {
        hideLoader();
      }
    };

    const deleteUserFromAMS = async (vendorCustomerId) => {
      showLoader();

      try {
        const obj = {
          vendorCustomerId: vendorCustomerId,
          companyId: selectedCompanyId,
        };

        const result = await deleteAMSUser(obj);
        console.log('await deleteAMSUser(obj); -- ', result);
        if (result.isSuccess) {
          console.log('User deleted successfully');
          toast.success("User deleted successfully");
          getUpdatedUserList();
        } else if (result.isError) {
          console.log("Not found - rollback archive");
          await archiveUserFromVendor(vendorCustomerId, false);
          toast.error("User not found", { autoClose: 2000 });
        }
      } catch (error) {
        console.log("delete error", error);
        toast.error("Delete failed", { autoClose: 2000 });
      } finally {
        hideLoader();
      }
    };

    const getUpdatedUserList = () => {
      getAccessGroupUsers({
        companyId: selectedCompanyId,
        type: "GET_ACCESSGROUP",
      }).then((result) => {
        setUserLoading(false);
        if (result.data.data?.length > 0) {
          dispatch(
            accessUserAction({
              accessUserList: result.data.data,
            })
          );
          handleClose(true);
        }
      });
    }
    

    const {
      accessGroupEventObject,
      accessGroupEventDialogOpen,
    } = accessGroupmodalState;

    const {
        AccessPointObject,
        eventDialogOpen,
    } = modalState;


    let { dialogValues, showEditorDialog, customerId } = addCustomerModalState;

    const {contractEventObject,contractEventDialogOpen} = contractmodalState;

    return(
        <Fragment>
        {!eventDialogOpen && !contractEventDialogOpen && !accessGroupEventDialogOpen &&
        <div>
          
          <div className="viewer_actions px-3 mb-3 d-flex align-items-center justify-content-between">
                <Breadcrumb routeSegments={[{ name: "Access users", path: "/" }, { name: "Bruker detaljer" }]} />

                <div className="d-flex align-items-center gap-2">
                    <Button className="mb-3" variant="primary" onClick={() => {
                                handleClose();}}>
                        <ArrowLeftCircle className={'me-2'} size={17}></ArrowLeftCircle>
                        Tilbake
                    </Button>
                    {
                      (!item.PropertyUnits || (item.PropertyUnits && item.PropertyUnits.length <= 0)) &&
                      
                      <Button className="mb-3 ml-2" variant="secondary" onClick={() => handleDeleteUserEvent(item)} >
                              <Trash className={'me-2'} size={17}></Trash>
                              Delete
                      </Button>
                    }
                </div>
            </div>
          <Row>
            <Col md={3}>
              <Card body className="mb-4">
                <div className="create_event_wrap">
                  <div className="viewer_actions px-3 mb-3 d-flex align-items-center justify-content-between">
                    <h4>Brukerdetaljer</h4>
                    <div className="d-flex align-items-center gap-2">
                      <span className="cursor-pointer text-primary" onClick={toggleEditorDialog}>
                          <PencilSquare size={17} className="me-2"/>
                        </span>
                    </div>
                  </div>

                  <ul className="list-group" id="external-events" >
                    <li style={{ backgroundColor: "#f5f5f5", color: "#000000" }}
                          className="list-group-item fc-event">
                          <i className="i-MaleFemale text-20 me-1" />
                          {userItem.CustomerName}
                    </li>
                    <li style={{ backgroundColor: "#f5f5f5", color: "#000000" }}
                          className="list-group-item fc-event">
                          <i className="i-Globe text-20 me-1" /> 
                          {userItem.Email}
                    </li>
                    {
                      item.personNumber && 
                      <li style={{ backgroundColor: "#f5f5f5", color: "#000000" }}
                          className="list-group-item fc-event">
                          <i className="i-ID-Card text-20 me-1" /> 
                          {userItem.personNumber}
                    </li>
                    }
                    
                    <li style={{ backgroundColor: "#f5f5f5", color: "#000000" }}
                          className="list-group-item fc-event">
                          <i className="i-Home1 text-20 me-1" />
                          {userItem.Address && userItem.Address.map((puItem, puIndex) => {
                                        return (
                                            <span>
                                              {puItem.AddressLine1} {puItem.AddressLine2} 
                                              {puItem.City} {puItem.ZipCode}
                                              {puItem.Country}
                                            </span>
                                        );
                                    })}
                    </li>
                    
                    
                  </ul>
                </div>
              </Card>
            </Col>
            <Col md={3}>
              <Card body className="mb-4 o-hidden">
                  <h4><i className="i-Home1 text-20 me-1" /> Liste over eiendomsenheter</h4>
                  <Table bordered
                          className="table table-bordered tbl-custom"
                          style={{ minWidth: 750 }}
                          >
                          <thead style={{borderTop: "1px solid #eeeeee", whiteSpace: "nowrap"}}>
                              <tr>
                                  <th className="py-3" align="left">
                                      Enheter
                                  </th>
                              </tr>
                          </thead>
                          {item.PropertyUnits && item.PropertyUnits.map((puItem, puIndex) => (
                              <tbody key={puIndex}>
                                  <tr>
                                      <td>
                                      <span className="cursor-pointer text-primary" onClick={() => handlePropertyUnitclick(puItem)}>
                                          {puItem.Propertyunit} ({puItem.Type})
                                      </span>
                                          
                                      </td>
                                  </tr>
                              </tbody>
                          ))}
                      </Table>
                </Card>
            </Col>
            <Col md={3}>
              <Card body className="mb-4 o-hidden">
                <h4><i className="i-Key text-20 me-1" />Liste over tilgangsgruppe</h4>
                <Table bordered
                        className="table table-bordered tbl-custom"
                        style={{ minWidth: 750 }}
                        >
                        <thead style={{borderTop: "1px solid #eeeeee", whiteSpace: "nowrap"}}>
                            <tr>
                                <th className="py-3" align="left">
                                  Tilgangsgruppe
                                </th>
                            </tr>
                        </thead>
                        {item.AccessGroups && item.AccessGroups.map((accessGroupItem, index) => (
                            <tbody key={index}>
                                <tr>
                                    <td>
                                    {/*  */}
                                    <span className="cursor-pointer text-primary" onClick={() => handleAccessGroupClick(accessGroupItem)}>
                                        {accessGroupItem.AccessGroup}
                                    </span>
                                        
                                    </td>
                                </tr>
                            </tbody>
                        ))}
                    </Table>
              </Card>
            </Col>
            <Col md={3}>
              <Card body className="mb-4 o-hidden">
                <h4><i className="i-Key text-20 me-1" />Liste over tilgangspunkter</h4>
                <Table bordered
                        className="table table-bordered tbl-custom"
                        style={{ minWidth: 750 }}
                        >
                        <thead style={{borderTop: "1px solid #eeeeee", whiteSpace: "nowrap"}}>
                            <tr>
                                <th className="py-3" align="left">
                                    Aksesspunkt
                                </th>
                            </tr>
                        </thead>
                        {accessPointList && accessPointList.map((accessPointitem, index) => (
                            <tbody key={index}>
                                <tr>
                                    <td>
                                    <span className="cursor-pointer text-primary" onClick={() => handleAccessPointClick(accessPointitem)}>
                                        {accessPointitem.FacilityName}
                                    </span>
                                        
                                    </td>
                                </tr>
                            </tbody>
                        ))}
                    </Table>
              </Card>
            </Col>
          </Row>
        </div>
        
        }
        {contractEventDialogOpen &&
           <ContractDetails open={contractEventDialogOpen} handleContractClose={closeContractModal} eventObject= {contractEventObject} />
        }
        {eventDialogOpen &&
            <AccessPointDetails
                open={eventDialogOpen}
                eventObject={AccessPointObject}
                closeDialog={closeAccessPointModal}
            />
        }
        {
          accessGroupEventDialogOpen && 
          <AccessGroupDetail
            open={accessGroupEventDialogOpen}
            eventObject={accessGroupEventObject}
            closeDialog={accessGroupToggleEventDialog}
            handleEventDialogSubmit={handleEventAccessGroupDialogSubmit}
          />
        }
        

      <AddCustomerModal
        show={showEditorDialog}
        initialValues={dialogValues}
        handleFormSubmit={handleFormSubmit}
        toggleEditorDialog={toggleEditorDialog}
        customerId = {customerId}
      />

      {loader}

        </Fragment>
    );
}

export default UserDetails;

export const prepareAccessGroupData = (options: any, selectedItems: any) => {
    // console.log('Options', options);
    // console.log('selectedItems', selectedItems);
  
    let tempdata = JSON.parse(JSON.stringify(options));
  
    if(tempdata && Array.isArray(tempdata) && tempdata.length > 0){
      // console.log('USEEFFECT ---------------------------------- ',);
      // Set already checked to false
      tempdata.forEach((item) => {
        if(item.checked === true){
          item.checked =  false;
        }
        let entrance = item.children;
        if(entrance && Array.isArray(entrance) && entrance.length > 0){
          entrance.forEach((entraceitem) => {
            if(entraceitem.checked === true){
              entraceitem.checked =  false;
            }
            let floor = entraceitem.children;
            if(floor && Array.isArray(floor) && floor.length > 0){
              floor.forEach((floorItem) => {
                if(floorItem.checked === true){
                  floorItem.checked =  false;
                }
              });
            }
          });
        }
      });
  
      // let
  
      //Select preselect data
      if(selectedItems && Array.isArray(selectedItems) && selectedItems.length > 0){
        tempdata.forEach((item) => {
          let ConcatID = item.ConcatID;
          if(item.checked === true){
            item.checked =  false;
          }
          var check = selectedItems.filter(a => a.ConcatID === ConcatID && a.AccessType === 'Direct');
          if(check && check.length > 0){
            item.checked = true;
          }
          let entrance = item.children;
          if(entrance && Array.isArray(entrance) && entrance.length > 0){
            entrance.forEach((entraceitem) => {
              var entranceCheck = selectedItems.filter(a => a.ConcatID === entraceitem.ConcatID&& a.AccessType === 'Direct');
              if(entranceCheck && entranceCheck.length > 0){
                entraceitem.checked = true;
              }
              let floor = entraceitem.children;
              if(floor && Array.isArray(floor) && floor.length > 0){
                floor.forEach((floorItem) => {
                  var floorCheck = selectedItems.filter(a => a.ConcatID === floorItem.ConcatID&& a.AccessType === 'Direct');
                  if(floorCheck && floorCheck.length > 0){
                    floorItem.checked = true;
                  }
                });
                entraceitem.children = floor;
              }
            });
            item.children = entrance;
          }
        });
      }
    }
  
  
    return refineOption(tempdata);
  };
  
  export const refineOption = (data: any) => {
    if(Array.isArray(data) && data.length){
      data.forEach(item => {
        item.checked = false;
        if(item.checked == null || item.checked == false){
          delete item.checked;
        }
        if(Array.isArray(item.children)){
          item.children = refineOption(item.children);
        }
      })
    }
    return data;
  };